import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout"
import EndorsementsLayout from "../components/endorsements-layout"

export default function Endorsements() {
  return (
    <Layout>
      <SEO title="2026 Endorsements for State Offices" />
      <EndorsementsLayout>
        {/* <h2 className="text-xl font-semibold mb-4">
          Endorsement Questionnaire
        </h2>
        <object
          data="/documents/CCLC 2026 Election Endorsement Questionnaire FINAL.pdf"
          type="application/pdf"
          width="100%"
          height="800"
        >
          <p>
            Your browser does not support embedded PDFs. You can still
            <a
              href="/documents/CCLC 2026 Election Endorsement Questionnaire FINAL.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              download the questionnaire here
            </a>
            .
          </p>
        </object> */}
      </EndorsementsLayout>
    </Layout>
  )
}
